import { useNavigate } from 'react-router-dom';
import { Card, Row, Tag, Typography } from 'antd';
import styled from 'styled-components';
import { ClockCircleOutlined } from '@ant-design/icons';
import useTranslations from '../../../../hooks/useTranslations';
import { useTherapistCtx } from '../context/TherapistContext';
import ListServices from '../../../../components/global/ListServices';

const { Text } = Typography;

const CardStyled = styled(Card)`
    height: 100%;
    .ant-card-body {
        height: 100%;
        padding: 12px;
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    }
`;

const proficiencyMap = {
    1: 'Beginner',
    2: 'Elementary',
    3: 'Intermediate',
    4: 'Advanced',
    5: 'Proficient/Native',
};

// Language codes to labels
const languageMap = {
    en: 'English',
    ko: 'Korean',
    th: 'Thai',
    ch: 'Chinese',
};

function AboutTherapist() {
    const navigate = useNavigate();
    const { t } = useTranslations();

    const { isLoading, therapist, services, isLoadingListService } = useTherapistCtx();

    const textOverview = t('Overview', 'Overview');
    const textAdditionalInformation = t('AdditionalInformation', 'Additional Information');
    const textServiceProvides = t('ServiceProvides', 'Service Provides');
    const textYearOfExperience = t('YearOfExperience', 'Year of experience');

    const languageText = therapist?.extinfo?.spoken_languages
        ?.map(({ lang_code, proficiency }) => {
            const level = proficiencyMap[proficiency] || 'Unknown';
            const lang = languageMap[lang_code] || lang_code;
            return `${level} ${lang}`;
        })
        .join(' | ');
    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
            <CardStyled loading={isLoading}>
                <Text strong>{textOverview}</Text>
                <Text type="secondary">{therapist?.bio}</Text>
                <Tag style={{ width: '100%', background: '#f3fbfa', border: 'unset' }}>
                    <Row align="middle" justify="space-between">
                        <div style={{ display: 'flex', gap: 8 }}>
                            <ClockCircleOutlined />
                            <Text>Working Hour :</Text>
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Text>
                                {therapist?.start_working_time} - {therapist?.end_working_time}
                            </Text>
                        </div>
                    </Row>
                </Tag>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 8,
                        marginTop: 8,
                    }}
                >
                    {therapist?.tags?.map((item, index) => (
                        <Tag
                            key={index}
                            style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                backgroundColor: '#DDF7F5',
                                color: '#111',
                                borderRadius: 8,
                                fontWeight: 500,
                                fontSize: 14,
                                padding: '4px 10px',
                                margin: 0,
                                border: 'unset',
                            }}
                        >
                            {item?.name}
                        </Tag>
                    ))}
                </div>
            </CardStyled>
            <CardStyled loading={isLoading}>
                <Text>{textAdditionalInformation}</Text>
                <Row style={{ display: 'flex', flexDirection: 'column', rowGap: 8 }}>
                    <Text type="secondary">
                        {therapist?.yoe} {textYearOfExperience}
                    </Text>
                    <Text type="secondary">
                        {therapist?.extinfo?.height}Cm | {therapist?.extinfo?.weight}Kg
                    </Text>
                    <Text type="secondary">{languageText}</Text>
                </Row>
            </CardStyled>
            <CardStyled loading={isLoading}>
                <Text>{textServiceProvides}</Text>
                <ListServices loading={isLoadingListService} dataSource={services} onClickItem={(item) => navigate(`/service-detail/${item?.id}`)} />
            </CardStyled>
        </div>
    );
}

export default AboutTherapist;
